module.exports = __webpack_public_path__ + "static/media/Charlotte_hoch.e4c87670.jpg";